/// <reference path="../paycards.js" />
import React, { Component } from 'react';
import { createRoot } from 'react-dom/client';
import { useSearchParams } from 'react-router-dom';
import moment from "moment";
import Swal from "sweetalert2";

import i18n from "i18next";
import { useTranslation } from "react-i18next";

import * as commonFunc from 'scripts/common';

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

import {
    Form, FormGroup,
    Button, Input, Label,
    Modal, ModalHeader, ModalBody, ModalFooter, Row, Col
} from "reactstrap";

import { Menu, Item, Separator, useContextMenu } from "react-contexify"
import "react-contexify/dist/ReactContexify.css";

import TakePhoto from "components/TakePhoto"

import ReportTabFrag from "components/generic/ReportTabFrag"
import TabFrag from "components/generic/TabFrag"
import CategoryFrag from "components/generic/CategoryFrag"
import HeaderFrag from "components/generic/HeaderFrag"
import GroupFrag from "components/generic/GroupFrag"
import ItemsContainerFrag from "components/generic/ItemsContainerFrag"
import EditTextFrag from "components/generic/EditTextFrag"
import SpinnerFrag from "components/generic/SpinnerFrag"
import ImageFrag from "components/generic/ImageFrag"
import ButtonFrag from "components/generic/ButtonFrag"
import CheckboxFrag from "components/generic/CheckboxFrag"
import RadioButtonsFrag from "components/generic/RadioButtonsFrag"
import PictureFrag from "components/generic/PictureFrag"
import TextViewFrag from "components/generic/TextViewFrag"
import FinderFrag from "components/generic/FinderFrag"
import CanvasFrag from "components/generic/CanvasFrag"
import ProgressBarFrag from "components/generic/ProgressBarFrag"

import SimpleListGeneric from "components/generic/alt/SimpleListGeneric"

import OffCanvas from 'components/OffCanvas';
import { GridStack } from 'gridstack';

//Config avec squelette des catégorie
// + data avec attribut=Catégorie
// >> Composant dédié pour afficher le html via config + data
//Voir pour gérer les fonctions du parent dans un objet pour qu'elles soit accessible via string

//Gérer un système de droit (information qui sera récupéré dans le Get de l'objet >> Voir avec Sébastien pour la gueule de l'objet (droit + catégories))


/*
baseValue = defaultValue
propNameType = type
attributes = regex
group = classParent
template = class OU classCollection = class
valueType = type front (Input, Select, TextArea etc…)
required = required
important = champs historique
*/

const tabRules = {
    "String": yup.string(),
    "Int32": yup.number(),
    "Object": yup.object(),
    "object": yup.object(),
};
const inputTypes = {
    "string": "text",
    "number": "number",
    "email": "email",
};

var dataCache = {};
var forcedCreate = false;
var isUpdateGen = false;

const AConfigureModel = React.forwardRef(({ onSubmit, noButtons, appProps, checkRights, getRoutes, getUser, modelsList, parentProps, keyMode, configModel, traceModel, loadedData, children, formEditing }, ref) => {
    const { t } = useTranslation();
    const altT = (label, args) => { return (label && label.startsWith("i18n:")) ? t(label.replace("i18n:", ""), args) : label };


    var curGenerateTag = "generate-" + Math.floor(Math.random() * 1000000000);

    if (loadedData) {
        if (loadedData.custom && loadedData.custom.extras && !loadedData.custom.orgExtras) {
            loadedData = JSON.parse(JSON.stringify(loadedData));
            loadedData.custom.orgExtras = loadedData.custom.extras;
            loadedData.custom.extras = {};
            console.debug(loadedData.custom.orgExtras);
            loadedData.custom.orgExtras.forEach((extra) => {
                loadedData.custom.extras[extra.name] = extra.value;
            });
        }
        else if (loadedData.extras && !loadedData.orgExtras) {
            loadedData = JSON.parse(JSON.stringify(loadedData));
            loadedData.orgExtras = loadedData.extras;
            loadedData.extras = {};
            console.debug(loadedData.orgExtras);
            loadedData.orgExtras.forEach((extra) => {
                loadedData.extras[extra.name] = extra.value;
            });
        }
    }

    var curElementList = {};
    const [elementList, setElementList] = React.useState({});
    const [genModel, setGenModel] = React.useState(configModel);
    const [selectedData, setSelectedData] = React.useState(null);
    const [displayMode, setDisplayMode] = React.useState(false);
    const [rerender, setRerender] = React.useState(false);

    const [searchParams, setSearchParams] = useSearchParams();

    if (formEditing === true || formEditing === false) {
        genModel.disabled = !formEditing;
    }
    isUpdateGen = (loadedData ? !forcedCreate : false);
    forcedCreate = false;

    var modalRoot;
    const showContextMenu = useContextMenu().show;
    const hideAllMenu = useContextMenu().hideAll;

    const modalGenManager = React.createRef();
    const offCanvasReportRef = React.createRef();

    const modelFctManager = {
        getRoutes: getRoutes,
        appProps: appProps,
        rootData: genModel,
        checkRights: checkRights,
        onActionRequired: () => {
            return new Promise((resolve, reject) => {
                resolve({ isSuccess: true });
            });
        },
        componentTyped: componentTyped,
        getRgbaFromHex: getRgbaFromHex,
        convertWidthToGrid: convertWidthToGrid,
        prepareMergedDesign: prepareMergedDesign,
        dropManager: dropManager,
        setCustomBackground: (design) => {
            var styleObject = {};
            if (design.backColor) styleObject.background = getRgbaFromHex(design.backColor);
            if (design.borderColor || design.borderSize) {
                if (design.borderColor) styleObject.borderColor = getRgbaFromHex(design.borderColor);

                if (design.borderSize) styleObject.borderWidth = design.borderSize;
                else styleObject.borderWidth = "1px";

                styleObject.borderStyle = "solid";
            }
            if (design.borderRadius) styleObject.borderRadius = design.borderRadius;

            return styleObject;
        },
        manageBoxSize: (tag, value, data) => {
            //MAJ gridstack en mode configuration
            var gridItems = data.grid.getGridItems();
            var filteredItems = gridItems.filter(item => item.id.endsWith(tag));
            if (filteredItems?.length) {
                var boxSize = parseFloat(value);
                boxSize = boxSize >= 0.05 ? boxSize : 0.2;
                data.gridWidth = Math.round(boxSize * 12);
                data.grid.update(filteredItems[0], { w: data.gridWidth });
            }
            return " col-12";
        },
        managePadding: (design, frameClass) => {
            var styleObject = {};
            if (design.padding) {
                styleObject.padding = design.padding;
            }
            if (design.paddingStart) {
                frameClass += " ps-0";
                styleObject.paddingLeft = design.paddingStart;
            }
            if (design.paddingTop) styleObject.paddingTop = design.paddingTop;
            if (design.paddingEnd) {
                frameClass += " pe-0";
                styleObject.paddingRight = design.paddingEnd;
            }
            if (design.paddingBottom) styleObject.paddingBottom = design.paddingBottom;

            return styleObject;
        },
        manageMargin: (design, frameClass) => {
            var styleObject = {};
            //TODO : marginElevation ???
            if (design.margin) {
                frameClass += " p-0";
                styleObject.margin = design.margin;
            }
            if (design.marginStart) {
                frameClass += " ps-0";
                styleObject.marginLeft = design.marginStart;
            }
            if (design.marginTop) styleObject.marginTop = design.marginTop;
            if (design.marginEnd) {
                frameClass += " pe-0";
                styleObject.marginRight = design.marginEnd;
            }
            if (design.marginBottom) styleObject.marginBottom = design.marginBottom;

            return styleObject;
        },
        setSelected: setSelected,
        finalizeProcess: finalizeProcess,
        commonRenderProc: commonRenderProc,
        dataCfg: parentProps ? parentProps.dataCfg : {}
    };

    var yupLocale = t("validation", { returnObjects: true });//TODO : fusion avec un json fourni par GetSchemaModel
    yup.setLocale(yupLocale);

    var keyArgs = ["min", "max", "length", "moreThan", "lessThan"];
    var customYup = {};
    customYup["phoneFr"] = function (yup, regex, excludeEmptyString, customMsg) {
        var phoneRegExp = /^(?:(?:\+|00)33[\s.-]{0,3}(?:\(0\)[\s.-]{0,3})?|0)[1-9](?:(?:[\s.-]?\d{2}){4}|\d{2}(?:[\s.-]?\d{3}){2})$/u;
        return yup.matches((regex || phoneRegExp), { message: customMsg || t("validation.string.phone"), excludeEmptyString: excludeEmptyString });
    };
    customYup["phone"] = function (yup, regex, excludeEmptyString, customMsg) {
        var phoneRegExp = /^(?:(?:\+|00)[1-9]{0,3}[\s.-]{0,3}(?:\(0\)[\s.-]{0,3})?|0)[1-9](?:(?:[\s.-]?\d{2}){4}|\d{2}(?:[\s.-]?\d{3}){2})$/u;
        return yup.matches((regex || phoneRegExp), { message: customMsg || t("validation.string.phone"), excludeEmptyString: excludeEmptyString });
    };


    React.useEffect(() => {
        //setElementList(curElementList);

        //TEMP - Timeout GridStack
        Swal.fire({
            title: "Chargement en cours...",
            didOpen: () => { Swal.showLoading() },
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
        });
        setTimeout(() => {
            Swal.close();
        }, 2500);


        return () => {
            //console.debug("unmount");
            if (modalRoot) {
                modalRoot.unmount();
                modalRoot = null;
            }
        }
    }, []);


    React.useEffect(() => {
        if (!genModel && traceModel && !commonFunc.isBlank(traceModel)) setGenModel(JSON.parse(traceModel));

        //TEMP - Timeout GridStack
        Swal.fire({
            title: "Chargement en cours...",
            didOpen: () => { Swal.showLoading() },
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
        });
        setTimeout(() => {
            Swal.close();
        }, 2500);

    }, [genModel]);

    React.useImperativeHandle(ref, () => ({
        submitForm: (isUpdate) => { handleSubmit((data) => { triggerOnSubmit(data, isUpdate) })() },
        resetForm: () => { reset(); },
    }));

    function triggerOnSubmit(data, isUpdate) {
        //Gestion des extras
        var extras = data.extras;
        data.extras = isUpdate ? (loadedData.custom ? (loadedData.custom.orgExtras || []) : (loadedData.orgExtras || [])) : [];

        var extrasType = parentProps.subType || parentProps.type;
        var primaryId = commonFunc.camelize("ID" + commonFunc.capitalize(extrasType), true);
        var secondaryId = commonFunc.camelize(extrasType + "ID", true);

        if (extras && Object.keys(extras).length) {
            var flagModifElem = false;
            Object.keys(extras).forEach((key) => {
                if (isUpdate) {
                    var existingExtra = data.extras.filter((extra) => extra.name === key);
                    if (existingExtra.length > 0) {
                        existingExtra.forEach((extra) => {
                            flagModifElem |= (extra.value !== extras[key]);
                            extra.value = extras[key];
                        });
                    }
                    else {
                        var extra = { name: key, value: extras[key], idExtra: 0 };
                        extra[secondaryId] = data[primaryId];
                        data.extras.push(extra);
                        flagModifElem = true;
                    }
                }
                else {
                    var extraAdd = { name: key, value: extras[key], idExtra: 0 };
                    extraAdd[secondaryId] = data[primaryId];
                    data.extras.push(extraAdd);
                }
            });
            if (flagModifElem) data.dSysMod = new Date();
        }

        var dataList = Object.keys(elementList).length > 0 ? elementList : curElementList;

        //Vérification validité adresse
        Object.keys(data).forEach((key) => {
            var field = data[key];
            //Reset des valeurs par défaut pour Adresse à -1
            if (field && field.idAddress && field.idAddress === -1) {
                if (!field.avoidReset) {
                    Object.keys(field).forEach((addressKey) => {
                        if (!commonFunc.isBlank(addressKey)) {
                            var child = dataList[commonFunc.camelize(key + "." + addressKey, true)];
                            if (child) {
                                var systemValue = "";
                                data[key][addressKey] = child.modalDefaultValue === undefined ? systemValue : child.modalDefaultValue;
                                //TODoO : check pour pb adresse
                            }
                        }
                    });
                }
                else {
                    Object.keys(field).forEach((addressKey) => {
                        if (!commonFunc.isBlank(addressKey)) {
                            var child = dataList[commonFunc.camelize(key + "." + addressKey, true)];
                            if (child && commonFunc.isBlank(data[key][addressKey]) && data[key][addressKey] !== 0) {
                                var systemValue = "";
                                data[key][addressKey] = child.modalDefaultValue === undefined ? systemValue : child.modalDefaultValue;
                                //TODoO : check pour pb adresse
                            }
                        }
                    });
                    field.idAddress = 0;
                }

                data[key + "ID"] = 0;
            }
            if (field && field.idAddress !== null && field.idAddress !== undefined && field.idAddress !== data[key + "ID"]) {
                data[key + "ID"] = field.idAddress;
            }
        });


        onSubmit(data, isUpdate).then((dataResult) => {
            if (dataResult && dataResult.idResponse) {
                Object.keys(dataList).forEach((key) => {
                    var dataElem = dataList[key];
                    if (dataElem.onModelSubmited) {
                        dataElem.functionManager.onSubmit(dataResult, dataResult.idResponse);
                    }
                });
            }
        });
    }


    //i18n.addResource('fr', 'translation', "tryit.label", 'hello from namespace 1');

    function createNestedObject(base, names, value) {
        // On récupère le dernier argument
        var lastName = arguments.length >= 3 ? names.pop() : false;
        // parcours de l'arbo, création si besoin
        for (var i = 0; i < names.length; i++) {
            base = base[names[i]] = base[names[i]] || {};
        }
        //on affecte la valeur  
        if (lastName) base = base[lastName] = value;
        return base;
    }

    function getValueFromNestedObject(object, value) {
        //récupère la valeur demandée
        return value.split('.').reduce((acc, curr) => acc[curr], object);
    }

    function setYupToNestedObject(obj) {
        //Appel récursif, a check sur plusieurs niveaux
        for (var propertyName in obj) {
            //console.debug(propertyName);
            //console.debug(typeof (obj[propertyName]));
            if (!(obj[propertyName].conditions)) {
                setYupToNestedObject(obj[propertyName]);
                obj[propertyName] = yup.object(obj[propertyName]).notRequired();
            }

        }
    }


    var nestedObj = {};
    var schemaObject = {};
    if (genModel && genModel.templates) {
        genModel.templates?.forEach((template) => {
            template.categories?.forEach((category) => {
                category.headers?.forEach((header) => {
                    header.groups?.forEach((group, index) => {
                        //Gestion des clé primaires/secondaires
                        if (parentProps && parentProps.type && keyMode > 0 && index === 0) {
                            var bindProp = "";
                            switch (keyMode) {
                                case 1: bindProp = "ID" + commonFunc.capitalize(parentProps.type); break;
                                case 2: bindProp = parentProps.type + "ID"; break;
                                default: bindProp = "ID" + parentProps.type; break;
                            }
                            group.items.push({ hidden: true, bindPropResult: bindProp, defaultValue: parentProps.id, objType: "textview" });
                        }

                        group.items?.forEach((item) => {//children
                            var type = item.propNameJsType || "string";
                            if (item.bindPropResult && yup[type] && typeof (yup[type]) === "function" && !item.bindPropResult.startsWith("{array}")) {//TEMP : test sur array en attendant solution pour les contacts de rapport
                                var elemYup = yup[type]();
                                if (item.propNameType) elemYup = tabRules[item.propNameType] || elemYup;
                                elemYup = elemYup.nullable();
                                if (item.attributes) {
                                    var errorMessage;
                                    if (item.attributes["typeName"] === "FormAttribute") errorMessage = altT(item.attributes["error"]);
                                    Object.keys(item.attributes).forEach((key, value) => {
                                        if (elemYup[key] && typeof (elemYup[key]) === "function") {
                                            try {
                                                if (errorMessage) {
                                                    if (keyArgs.indexOf(key) >= 0 && item.attributes[key]) {
                                                        elemYup = elemYup[key](item.attributes[key], errorMessage);
                                                    }
                                                    else if (key === "oneOf" && item.attributes[key]) {
                                                        elemYup = elemYup[key]([yup.ref(commonFunc.camelize(item.attributes[key], true))], errorMessage);
                                                    }
                                                    else if (item.attributes[key]) {
                                                        elemYup = elemYup.matches(item.attributes[key], { message: errorMessage, excludeEmptyString: (item.attributes["required"] ? false : true) });
                                                    }
                                                    else {
                                                        elemYup = elemYup[key](errorMessage);
                                                    }
                                                }
                                                else {
                                                    if (keyArgs.indexOf(key) >= 0 && item.attributes[key]) {
                                                        elemYup = elemYup[key](item.attributes[key]);
                                                    }
                                                    else if (key === "oneOf" && item.attributes[key]) {
                                                        elemYup = elemYup[key]([yup.ref(commonFunc.camelize(item.attributes[key], true))]);
                                                    }
                                                    else if (item.attributes[key]) {
                                                        elemYup = elemYup.matches(item.attributes[key], { excludeEmptyString: (item.attributes["required"] ? false : true) });
                                                    }
                                                    else {
                                                        elemYup = elemYup[key]();
                                                    }
                                                }
                                            }
                                            catch (e) {
                                                console.debug("Error manipulating yup attributes");
                                                console.error(e);
                                            }
                                        }
                                        else if (customYup[key] && typeof (customYup[key]) === "function") {
                                            elemYup = customYup[key](elemYup, item.attributes[key], (item.attributes["required"] ? false : true), errorMessage);
                                        } else {

                                            //console.debug("yup function type " + key + " Ignored");
                                        }
                                    });
                                }

                                elemYup = elemYup.typeError(t("validation." + type + ".notType"));

                                if (item.bindPropResult.indexOf(".") >= 0) {
                                    if (!item.isExcluded) {
                                        //On met de côté les objets sous-jacents pour traitement final (propriétés non consécutives)
                                        createNestedObject(nestedObj, commonFunc.camelize(item.bindPropResult, true).split("."), elemYup);
                                    }
                                } else {

                                    schemaObject[commonFunc.camelize(item.bindPropResult, true)] = elemYup;//.required()
                                }
                                /*if (item.bindPropResult === "Address.AddressMain" && item.bindPropResult.indexOf(".") >= 0) {
                                    schemaObject["address"] = {};
                                    schemaObject["address"]["addressMain"] = elemYup;
                                }*/


                                //localDataConfig.push({ label: "i18n:" + key + "Label", type: "input", target: key, className: "" });//TEMP
                                if (!item.baseConfig) item.baseConfig = {};
                                //localDataConfig.push({ title: "i18n:report_" + elem.propName + ".label", objType: "text", bindPropResult: elem.propName, defaultValue: elem.baseValue, subType: (inputTypes[elem.propNameJsType] || "text"), readOnly: elem.baseConfig.readOnly, hidden: elem.baseConfig.hidden, isInput: elem.baseConfig.isInput });//TEMP
                            } else {

                                //console.debug("yup base type " + type + " Ignored");
                            }
                        });
                    });
                });
            });
        });
    }
    //TEMP
    /*schemaObject.contacts = yup.array().of(yup.object().shape({
        name: yup.string().required().min(5),
        firstName: yup.string().required().min(5)
    }));*/

    //On genere le yup pour les objets sous-jacents
    setYupToNestedObject(nestedObj);
    Object.assign(schemaObject, nestedObj);

    //console.debug(nestedObj);
    //console.debug(schemaObject);
    //console.debug("....*****");

    const currSchema = yup.object(schemaObject).required();
    const { control, register, getValues, trigger, setValue, resetField, handleSubmit, reset, formState: { errors }, clearErrors } = useForm({ resolver: yupResolver(currSchema) });//{ resolver: yupResolver(currSchema), defaultValues: { ClientName: "toto" } }
    const formManager = {
        control: control,
        register: register,
        getValues: getValues,
        setValue: setValue,
        resetField: resetField,
        handleSubmit: handleSubmit,
        reset: reset,
        errors: errors
    };

    var cpt = 0;

    //console.debug("ALERTE RENDER !!");
    //console.debug(elementList);

    function excludeFrag(bindProp, type) {
        if (bindProp) {
            if (bindProp.indexOf(".") >= 0) {
                var exParent = excludeFrag(bindProp.split(".")[0]);
                return bindProp.replace(bindProp.split(".")[0], exParent) + "_" + (type || "temp");
            }
            else {
                return bindProp + "_" + (type || "temp");
            }
        }
        else {
            return "";
        }
    }

    function commonRenderProc(data) {//TODO : remise a zero nécéssaire pour pas que ça passe tout le temps les prochaines fois
        var parentProps = data?.functionManager?.getParentProps();
        var childCount = parentProps?.parentData?.childCount || 1;
        var childRendered = parentProps?.parentData?.childRendered || 0;

        //console.debug("CHECK RENDERER " + data.objType + " " + data.childRendered + "/" + (data.childCount ? data.childCount : 0));
        //Vérification d'éligibilité de la cible pour gestion parent
        if (data.childRendered >= (data.childCount ? data.childCount : 0)) {
            if (parentProps?.parentData) parentProps.parentData.childRendered = childRendered + 1;

            console.debug("GO RENDERER " + data.objType + " " + parentProps?.parentData?.childRendered + "/" + childCount);

            if (parentProps?.parentData?.childRendered >= childCount /*&& parentProps?.parentData?.loaded*/) {
                var grid = data.grid || parentProps?.parentData?.grid || parentProps?.parentData?.functionManager.getParentProps()?.parentData?.grid
                    || parentProps?.parentData?.functionManager.getParentProps()?.parentData?.functionManager?.getParentProps()?.parentData?.grid;
                if (grid) {
                    var itemsHTML = grid.getGridItems();
                    itemsHTML.forEach((item) => {
                        grid.resizeToContent(item);
                    });
                }

                var parentSupProps = parentProps?.parentData?.functionManager?.getParentProps() || parentProps?.parentData?.functionManager.getParentProps()?.parentData?.functionManager?.getParentProps()
                    || parentProps?.parentData?.functionManager.getParentProps()?.parentData?.functionManager?.getParentProps()?.parentData?.functionManager?.getParentProps();
                if (parentSupProps) {
                    //if (parentSupProps?.parentData?.childRendered >= childCount) parentSupProps.parentData.childRendered = 0;
                    commonRenderProc(parentProps.parentData);
                }
            }
        }
    }

    function componentTyped(element, parentElemProps) {
        if (!element.title) element.title = "";
        if (!element.baseConfig) element.baseConfig = {};

        element.key = element.key || cpt;
        element.required = element.attributes && (element.attributes.required !== undefined || (element.attributes.min && parseInt(element.attributes.min) > 0));
        if (!element.argumentsObj && element.arguments) {
            if (typeof element.arguments == "string") element.argumentsObj = JSON.parse(element.arguments);
            else { element.argumentsObj = element.arguments; }
        }

        //Préparation du bindPropResult + stockage dans la liste Composant
        var camelBindProp;
        var preventLoadedData = false;
        if (!commonFunc.isBlank(element.bindPropResult)) {
            if (element.bindPropResult.indexOf("{array}") >= 0) {
                camelBindProp = commonFunc.camelize(element.bindPropResult.replace("{array}", commonFunc.camelize(parentElemProps.parentData.isInfluencedBy || parentElemProps.parentData.bindPropResult, true) + (parentElemProps.parentData.isExcluded ? "_temp" : "") + "[" + parentElemProps.parentData.key + "]"), true);
                preventLoadedData = true;
            }
            else {
                camelBindProp = commonFunc.camelize(element.bindPropResult, true);
            }
            curElementList[camelBindProp] = element;
        }
        else {
            camelBindProp = element.bindPropResult;
        }

        cpt++;

        if (!preventLoadedData && (loadedData && !commonFunc.isBlank(camelBindProp))) {
            if (!element.modalDefault) {
                element.modalDefaultValue = element.defaultValue;
                element.modalDefault = true;
            }
            //console.debug(loadedData);
            var srcValue = commonFunc.getValue(loadedData, camelBindProp);
            if (element.objType === "picture") {
                if (typeof srcValue === 'object' && !Array.isArray(srcValue) && srcValue !== null) {
                    element.defaultValue = "";//TODO : Downloadfile valide
                }
                else {
                    element.defaultValue = ((srcValue !== null && srcValue !== undefined) ? srcValue : element.defaultValue);
                }
            }
            else {
                element.defaultValue = ((srcValue !== null && srcValue !== undefined) ? srcValue : element.defaultValue);
            }
        }

        //Alimentation du mergedDesign
        manageComponentDesign(element, genModel);


        var args = {
            key: element.key,
            data: element,
            formManager: formManager,
            parentDisabled: (parentElemProps ? parentElemProps.parentDisabled : false),
            parentProps: parentElemProps,
            modelFctManager: modelFctManager,
            isConfiguration: true,
            bindPropResult: (element.isExcluded ? excludeFrag(camelBindProp, element.subType) : camelBindProp)
        };
        switch (element.objType) {
            case "model": return <ReportTabFrag {...args} />;
            case "template": return <TabFrag {...args} />;
            case "category": return <CategoryFrag {...args} />;
            case "header": return <HeaderFrag {...args} />;
            case "group": return <GroupFrag {...args} />;
            case "itemsContainer": return <ItemsContainerFrag {...args} />;

            case "image": return <ImageFrag {...args} />;
            case "button": return <ButtonFrag {...args} />;
            case "text": return <EditTextFrag {...args} />;
            case "dropdown":
            case "select":
                return <SpinnerFrag {...args} />;
            case "checkbox": return <CheckboxFrag {...args} />;
            case "radio": return <RadioButtonsFrag {...args} />;
            case "picture": return <PictureFrag {...args} srcFileManager={{ className: curGenerateTag, showContextMenu: showContextMenu, hideAllMenu: hideAllMenu }} />;
            case "textview": return <TextViewFrag {...args} />;
            case "finder": return <FinderFrag {...args} />;
            case "canvas": return <CanvasFrag {...args} />;
            case "progressBar": return <ProgressBarFrag {...args} />;

            case "simpleList": return <SimpleListGeneric {...args} accessList={Object.keys(elementList).length > 0 ? elementList : curElementList} />;
            default:
                //Finalize quand même sur les composants inexistant pour la gestion du parent
                args.modelFctManager.finalizeProcess(element, args.parentProps);
                return "";
        }
    }


    function renderData(cfg) {
        curElementList = {};

        var content = cfg ? componentTyped(cfg) : "";

        return <Form action="" className={`form needs-validation h-100 ${curGenerateTag}`} method="" onSubmit={handleSubmit((data) => { triggerOnSubmit(data, false) })}>
            <Button className="btn-round mb-3 float-sm-start" color="primary" onClick={saveModel}><i className="fa fa-save me-2"></i>Sauvegarder</Button>
            {false && isUpdateGen ? <Button className="btn-round mb-3 float-sm-start" color="primary" onClick={() => { handleSubmit((data) => { triggerOnSubmit(data, true) })() }}>Modifier</Button> : ""}
            <Button className="btn-round mb-3 float-sm-start" color="primary" onClick={changeDisplay}>Changer Affichage</Button>
            <Button className="btn-round mb-3 float-sm-start" color="danger" onClick={resetModel}>Réinitialiser</Button>
            <Button className="btn-round mb-3 float-sm-start" color="success" onClick={addComponent}>Ajouter Composant</Button>
            <div className={`w-100 ${displayMode ? "alt-display" : ""}`}>
                {content}
                {children}
            </div>
        </Form>;
    }

    /*Notes :
        ReportItem :
            //Dictionnaire d'action (onChange/onLoad : évènement où l'appel va se faire | trigger : action à effectuer | target : cible de l'action | value : valeur a communiquer pour l'action)
            onActionEvents: { onChange: [{ trigger: "duplicateManualReport", target: "target1", value: "value" }], onLoad: [{ trigger: "setValue", target: "", value: "options" }] },
    
            
            defaultValue: "10",//Valeur initial du rapport
            rawValue: "2.1",//valeur brut avant formattage
            value: "2",//Valeur finale
            
            rightAccess: "MUPD",//Gestion des drotis d'accès
            isExcluded: true,//Exlusino de la récupération pour sauvegarde
            dataCache : {} //sous objet de gestion de chargement de l'item
                shouldLoadDefaultValue: true, //défini si il faut charger la valeur par défaut dans le ReportItem
                loadFromCache: true//défini si on doit charger les données depuis le cache
                loadWhenGenerating: true//défini si on doit charger les données à la génération du rapport
            schema: {} //objet basé sur GetSchemaModel


            temporary : true //Défini si il s'agit d'un ReportItem qui doit être supprimé si réinitialisation (un peu comme isCloned)
            isLoaded : true //Défini si les traitement ont déjà été effectué sur un fragment

            Design :
                Gérer une option no padding sur parent
                spacing : 1 //Gestion d'un espacement sur les enfants

    */

    //Laison avec commonRenderProc suite au setRerender suivant la fonction depuis la source "onDropped"
    function dropManager(data, event, prevNode, n) {
        if (n.el.hasAttribute("bind-type")) {
            var childsList = [...event.target.children];
            childsList.sort(function (a, b) {
                var aX = a.getAttribute("gs-x");
                var aY = a.getAttribute("gs-y");
                var bX = b.getAttribute("gs-x");
                var bY = b.getAttribute("gs-y");
                var tst = parseInt(aY) - parseInt(bY);
                if (!tst) tst = parseInt(aX) - parseInt(bX);
                return tst;
            });
            var index = childsList.indexOf(n.el);
            console.debug(index);
            var nextItem = childsList[index + 1];
            var modif = 1
            /*if (!nextItem) {
                nextItem = childsList[index - 1];
                modif = -1;
            }*/
            if (!nextItem) {
                modif = 0;
            }

            var childsData;
            var tag = "item";
            switch (data?.objType) {
                case "template":
                    childsData = data.categories;
                    tag = "category";
                    break;
                case "category":
                    childsData = data.headers;
                    tag = "header";
                    break;
                case "header":
                    childsData = data.groups;
                    tag = "group";
                    break;
                case "group":
                    childsData = data.items;
                    break;
                case "itemsContainer":
                default:
                    childsData = data.children;
                    break;
            }


            //childsData.filter(item => item.id === nextItem.id);

            var dataModel;
            switch (n.el.getAttribute("bind-type")) {
                case "template":
                    dataModel = { objType: "template", title: "TAB#", categories: [], bindPropResult: "addedtemplate-" + data.gridID + "-" + Math.floor(Math.random() * 1000000000), customDesign: { design: { backColor: "#FFFF0000" } } };
                    break;
                case "category":
                    dataModel = { objType: "category", title: "Titre Catégorie", headers: [], bindPropResult: "addedcategory-" + data.gridID + "-" + Math.floor(Math.random() * 1000000000), customDesign: { design: { backColor: "#FFFF0000" } } };
                    break;
                case "header":
                    dataModel = { objType: "header", title: "Titre Sous-Catégorie", groups: [], bindPropResult: "addedheader-" + data.gridID + "-" + Math.floor(Math.random() * 1000000000), customDesign: { design: { backColor: "#FFFF0000" } } };
                    break;
                case "group":
                    dataModel = { objType: "group", title: "", items: [], bindPropResult: "addedgroup-" + data.gridID + "-" + Math.floor(Math.random() * 1000000000), customDesign: { design: { backColor: "#FFFF0000" } } };
                    break;
                case "itemsContainer":
                    dataModel = { objType: "itemsContainer", title: "", children: [], bindPropResult: "addeditems-" + data.gridID + "-" + Math.floor(Math.random() * 1000000000), customDesign: { design: { backColor: "#FFFF0000" } } };
                    break;
                default:
                    dataModel = { objType: n.el.getAttribute("bind-type"), title: "TEST", bindPropResult: "added-" + data.gridID + "-" + Math.floor(Math.random() * 1000000000), customDesign: { design: { backColor: "#FFFF0000" } } };
                    break;
            }



            //Gestion alimentation des données
            if (!modif) {
                childsData.push(dataModel);
            }
            else {
                var addDone = false;
                //var grid = (childsData && childsData.length ? childsData[0].grid : null);
                var parentGrid = childsData?.filter(child => child.grid ? true : false);
                if (parentGrid && parentGrid.length) {
                    var grid = parentGrid[0].grid;
                    var gridItems = grid.getGridItems();
                    gridItems.forEach(gridItem => {
                        if (gridItem.gridstackNode.el === nextItem) {
                            var target = childsData.filter((item, index) => ((tag + "-" + data.gridID + "-" + (item?.key || index)) === gridItem.gridstackNode.id));
                            if (target && target.length) {
                                var targetIndex = childsData.indexOf(target[0]);

                                if (targetIndex >= 0) {
                                    childsData.splice(targetIndex /*- modif*/, 0, dataModel);
                                    addDone = true;
                                }
                            }
                        }
                    });
                }
                if (!addDone) {
                    childsData.push(dataModel);
                }

                console.debug(childsData.map(item => item.bindPropResult).join(";"));
            }
            data.childRendered = 0;

            n.el.remove();


            //TEMP - Timeout GridStack
            Swal.fire({
                title: "Chargement en cours...",
                didOpen: () => { Swal.showLoading() },
                allowOutsideClick: false,
                allowEscapeKey: false,
                allowEnterKey: false,
            });
            setTimeout(() => {
                Swal.close();
            }, 2500);
        }
    }

    function manageComponentDesign(data, genModel) {
        var design = data.customDesign?.design;

        var defaultKey = "";
        switch (data.objType) {
            case "model": defaultKey = "default_model"; break;
            case "template": defaultKey = "default_template"; break;
            case "category": defaultKey = "default_category"; break;
            case "header": defaultKey = "default_header"; break;
            case "group": defaultKey = "default_group"; break;
            case "containerItem":
            case "itemsContainer":
                defaultKey = "default_itemsContainer"; break;

            case "button":
            case "submit":
                defaultKey = "default_button"; break;
            case "text": defaultKey = "default_text"; break;
            case "select":
            case "spinner":
            case "dropdown":
                defaultKey = "default_select"; break;
            case "checkbox": defaultKey = "default_checkbox"; break;
            case "radio": defaultKey = "default_radio"; break;
            case "picture": defaultKey = "default_picture"; break;
            case "textview": defaultKey = "default_textview"; break;
            case "finderText":
            case "finder":
                defaultKey = "default_finder"; break;
            case "canvas": defaultKey = "default_canvas"; break;
            case "progressBar": defaultKey = "default_progressBar"; break;

            case "simpleList": defaultKey = "default_simpleList"; break;
            default:
                break;
        }

        design = prepareMergedDesign(data, design, defaultKey);
        data.mergedDesign = design;
    }

    function prepareMergedDesign(data, designFragment, defaultDesignKey, forcedMerge) {
        if (forcedMerge || !data.mergedDesign) {
            var altDesign = genModel.customDesign?.extrasDesign;
            var targetDesign = (designFragment && !commonFunc.isBlank(designFragment.fromDesign)) ? designFragment.fromDesign : defaultDesignKey;
            var rootDesign = altDesign ? altDesign[targetDesign] : null;
            return getMergedDesign(data, designFragment, rootDesign, forcedMerge);
        }
        else {
            designFragment = forcedMerge ? designFragment : data.mergedDesign;
        }
        return designFragment;
    }

    function prepareModelToSave(model) {
        return JSON.stringify(model, (key, value) => {
            if (key === "baseConfig" || key === "functionManager" || key === "argumentsObj" || key === "isLoaded" || key === "mergedDesign" || key === "grid" || key === "gridWidth" || key === "gridID" || key === "lastEvent" || key === "allowBoxSize") {
                return undefined;
            }
            if (key === "key" || key === "loaded" || key === "childCount" || key === "childLoaded" || key === "childRendered" || key === "modalDefault" || key === "modalDefaultValue") {
                return undefined;
            }
            if (key === "required" && value === true) return undefined;
            if (key === "boxSize" && value === "0") return "";
            return value;
        });
    }


    function saveModel() {
        console.debug(genModel);

        var entity = searchParams.get("entity");
        var categ = searchParams.get("categ");
        var extID = searchParams.get("extID");

        if (entity && extID && categ) {
            Swal.fire({
                title: "Sauvegarde en cours...",
                didOpen: () => { Swal.showLoading() }
            });

            var args = {};
            var url = "api/" + entity;
            if (genModel.idModel) {
                url += "/Update";
                args.idModel = genModel.idModel;
            }
            else {
                url += "/Add";
                args.idModel = 0;
            }
            url += entity;
            url += "Model";

            args.title = "Saved Model";
            args.extID = "SAVED-" + extID;
            args.categ = categ;
            args.value = prepareModelToSave(genModel);


            commonFunc.postMethod("../" + url, args).then((response) => {
                var data = response.data;
                if (data.isSuccess) {
                    Swal.fire({
                        icon: "success",
                        title: "Succès",
                        html: "Sauvegarde de modèle effectuée avec succès.",
                        didOpen: () => {
                            Swal.hideLoading();
                        },
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        allowEnterKey: false,
                    }).then((result) => {
                        //window.location.reload();
                    });
                }
                else {
                    Swal.fire({
                        icon: "error",
                        title: "Echec",
                        html: "Echec de sauvegarde<br/>" + response.data.errorMessage
                    });
                }
            });
        }
        else {
            Swal.fire({
                icon: "error",
                title: "Echec",
                html: "Arguments URL pour sauvegarde manquant"
            });
        }
    }

    function changeDisplay() {
        setDisplayMode(!displayMode);
    }

    function resetModel() {
        setGenModel(null);
        //if (traceModel && !commonFunc.isBlank(traceModel)) setGenModel(JSON.parse(traceModel));
        //setRerender(!rerender);
    }

    function addComponent() {
        offCanvasReportRef.current.open();

        //TODO : load templates
    }

    function setSelected(grid, dataSel) {
        console.debug(dataSel?.lastEvent);
        if (!dataSel?.lastEvent?.target?.classList?.contains("ui-resizable-handle") && !dataSel?.lastEvent?.target?.classList?.contains("remove-gridstack")) {
            setSelectedData(dataSel);

            var gridItems = grid.getGridItems();
            var filteredItems = gridItems.filter((item) => { return item.id.endsWith(dataSel.functionManager?.getParentProps()?.parentData?.gridID + "-" + dataSel.key); });
            if (filteredItems.length) {
                if (!filteredItems[0].classList.contains("selected-item")) {
                    var selElements = document.getElementsByClassName("selected-item");
                    if (selElements && selElements.length) {
                        Array.from(selElements).forEach((elem) => {
                            elem.classList.remove("selected-item");
                        });
                    }
                    filteredItems[0].classList.add("selected-item");
                }
                else {
                    filteredItems[0].classList.remove("selected-item");
                    setSelectedData(null);
                }
            }
        }
    }


    const content = renderData(genModel);

    console.debug(errors);
    console.debug(getValues());


    //Check object complexity
    var manageBackInput = false, manageBackTitle = false, manageBackIcon = false, managePadding = false, manageMargin = false, manageWidth = false,
        manageMaxWidth = false, manageHeight = false, manageSpacing = false, manageAlignment = false, manageGroupOthers = false;

    var listOptions = {
        back: (cfgData, path) => {
            return <div className="mt-3">
                <FormGroup className="mb-0">
                    <Input type="color" className="d-inline-block" autoComplete="no" aria-autocomplete="none" value={"#" + cfgData.customDesign?.design?.backColor?.slice(3)} onChange={(event) => {
                        if (!cfgData.customDesign) cfgData.customDesign = {};
                        if (!cfgData.customDesign[path]) cfgData.customDesign[path] = {};
                        cfgData.customDesign[path].backColor = event.target.value.replace("#", "#FF");//TODO : gérer l'alpha
                        cfgData.mergedDesign = null;
                        cfgData.functionManager.rerender();
                        setRerender(!rerender);
                    }} style={{ width: "50px" }} />
                    <Label className="ms-2">Couleur de fond</Label>
                </FormGroup>
                <FormGroup className="mb-0">
                    <Input type="color" className="d-inline-block" autoComplete="no" aria-autocomplete="none" value={"#" + cfgData.customDesign?.design?.borderColor?.slice(3)} onChange={(event) => {
                        if (!cfgData.customDesign) cfgData.customDesign = {};
                        if (!cfgData.customDesign[path]) cfgData.customDesign[path] = {};
                        cfgData.customDesign[path].borderColor = event.target.value.replace("#", "#FF");//TODO : gérer l'alpha
                        cfgData.mergedDesign = null;
                        cfgData.functionManager.rerender();
                        setRerender(!rerender);
                    }} style={{ width: "50px" }} />
                    <Label className="ms-2">Couleur de la bordure</Label>
                </FormGroup>
            </div>;
        },
        boxSize: (cfgData, path, onOffMode) => {
            var boxSize = (selectedData.customDesign ? selectedData.customDesign[path]?.boxSize : 0);
            console.debug(boxSize);
            return onOffMode ? <FormGroup check className='text-start fcheck-sm'>
                    <Label check>
                    <Input checked={boxSize === "1" ? true : false} type="checkbox" onChange={(event) => {
                        if (!cfgData.customDesign) cfgData.customDesign = {};
                        if (!cfgData.customDesign[path]) cfgData.customDesign[path] = {};
                        cfgData.customDesign[path].boxSize = event.target.checked ? "1" : "0";
                        cfgData.mergedDesign = null;
                        cfgData.functionManager.rerender();
                        setRerender(!rerender);
                    }} />
                        <span className="form-check-sign" />
                        Prendre la taille de la ligne ?
                    </Label>
                </FormGroup>
                : <FormGroup className="mb-0">
                    <Label for="exampleRange">
                        Poids (weight)
                    </Label>
                    <Input type="range" value={(parseFloat(boxSize) * 100) || 0} onChange={(event) => {
                        if (!cfgData.customDesign) cfgData.customDesign = {};
                        if (!cfgData.customDesign[path]) cfgData.customDesign[path] = {};
                        var boxSizeChange = (event.target.value / 100);
                        cfgData.customDesign[path].boxSize = (boxSizeChange >= 0.01 ? boxSizeChange?.toString() : "");
                        cfgData.mergedDesign = null;
                        cfgData.functionManager.rerender();
                        setRerender(!rerender);
                    }} />
                </FormGroup>;
        }
    };
    var renderOptions = [];

    switch (selectedData?.objType) {
        case "template":
        case "category":
        case "header":
            renderOptions.push(listOptions["back"](selectedData, "design"));
            renderOptions.push(listOptions["boxSize"](selectedData, "design"));//Influence son parent en horizontal si renseigné
            managePadding = true;
            manageMargin = true;
            manageWidth = true;
            manageHeight = true;
            break;
        case "group":
            renderOptions.push(listOptions["back"](selectedData, "design"));
            renderOptions.push(listOptions["boxSize"](selectedData, "design", true));
            managePadding = true;
            manageMargin = true;
            manageWidth = true;
            manageMaxWidth = true;
            manageHeight = true;
            manageSpacing = true;
            manageAlignment = true;
            manageGroupOthers = true;
            break;
        case "itemsContainer":
            renderOptions.push(listOptions["back"](selectedData, "design"));
            renderOptions.push(listOptions["boxSize"](selectedData, "design"));
            managePadding = true;
            manageMargin = true;
            manageWidth = true;
            manageHeight = true;
            manageSpacing = true;
            manageAlignment = true;
            break;
        case "button":
            renderOptions.push(listOptions["back"](selectedData, "design"));
            renderOptions.push(listOptions["boxSize"](selectedData, "design"));
            manageWidth = true;
            manageHeight = true;
            break;
        default:
            if (!commonFunc.isBlank(selectedData?.objType)) {
                renderOptions.push(listOptions["boxSize"](selectedData, "design"));
            }
            break;
    }

    var modelsOpts = {
        onMouseDown: () => {
            setTimeout(() => {
                offCanvasReportRef.current.manageVisibility(false);
            }, 200);
        },
        "gs-w": 2
    };

    return <><Row className="editor-model h-100">
            <Col className="h-100" xs="9">{content}</Col>
            <Col className="h-100 text-dark" xs="3">
                {selectedData ? ((() => {
                    var path = [];

                    var getParentType = (data) => {
                        if (data.functionManager?.getParentProps) {
                            var parentProps = data.functionManager.getParentProps();
                            //Vérification sur le grid pour éviter la sélection sur  du vide
                            if (parentProps?.parentData?.grid) {
                                if (parentProps?.parentData?.functionManager?.getParentProps && parentProps.parentData.functionManager.getParentProps()?.parentData) {
                                    //path.unshift(parentProps?.parentData?.objType);
                                    path.unshift(<u className="cursor-pointer" onClick={(e) => { setSelected(parentProps.parentData.grid, parentProps.parentData) }}>{parentProps?.parentData?.objType}</u>);
                                    getParentType(parentProps.parentData/*.functionManager.getParentProps()?.parentData*/);
                                }
                                else {
                                    //path.unshift(parentProps?.parentData?.objType);
                                    path.unshift(<u className="cursor-pointer" onClick={(e) => { setSelected(parentProps.parentData.grid, parentProps.parentData) }}>{parentProps?.parentData?.objType}</u>);
                                }
                            }
                        }
                    };

                    getParentType(selectedData);

                    //path.push(selectedData.objType);
                    //return path.join(" > ");
                    path.push(<b>{selectedData.objType}</b>);
                    return path.map((item) => { return <span>{" > "}{item}</span>; });
                })()) : ""}

                {renderOptions.map(cfgOption => cfgOption)}


                {manageGroupOthers ? <div>subType ??? (linear/spreadInside/packed)<br />renderLink/groupSubName (header/category)<br/>clonage etc...</div> : ""}
            </Col>
        </Row>
        <OffCanvas className={``} btnGroupClass={"d-none"} ref={offCanvasReportRef} onOpened={() => { GridStack.setupDragIn('.models-container .grid-model', { appendTo: 'body', helper: "clone" }); }}
            direction={"end"} title={"Ajout Composant"} backdrop={false} scrollable={true}>

            <div className="d-none">TODO mix Accordion</div>

            <div className="models-container">
                <div className="grid-stack-item grid-model grid-category" bind-type="category" {...modelsOpts} gs-w="12" gs-h="2"><div className="grid-stack-item-content text-dark">Categorie</div></div>
                <div className="grid-stack-item grid-model grid-header" bind-type="header" {...modelsOpts} gs-w="12" gs-h="2"><div className="grid-stack-item-content text-dark">Sous-Categorie</div></div>
                <div className="grid-stack-item grid-model grid-group" bind-type="group" {...modelsOpts} gs-w="12" gs-h="2"><div className="grid-stack-item-content text-dark">Groupe</div></div>
                <div className="grid-stack-item grid-model grid-item" bind-type="text" {...modelsOpts} gs-h="2"><div className="grid-stack-item-content text-dark">Champ Texte</div></div>
                <div className="grid-stack-item grid-model grid-item" bind-type="textview" {...modelsOpts}><div className="grid-stack-item-content text-dark">Texte</div></div>
                <div className="grid-stack-item grid-model grid-item" bind-type="dropdown" {...modelsOpts} gs-h="2"><div className="grid-stack-item-content text-dark">Liste déroulante</div></div>
            </div>
        </OffCanvas>
    </>;

});

export default AConfigureModel;

export function getRgbaFromHex(hex) {
    if (hex.length == 9) {
        var alpha = parseInt(hex.slice(1, 3), 16) / 255;
        var hex = commonFunc.hexToRgb(hex.substring(3));
        var rgba = "rgba(" + hex + "," + alpha.toFixed(2) + ")";

        return rgba;
    } else {
        return commonFunc.hexToRgb(hex);
    }
}

export function convertWidthToGrid(widthPercent, withoutClass) {
    var gridValue = Math.round(widthPercent / 100 * 12);
    if (withoutClass) return gridValue;
    return " col-12 col-md-" + gridValue;
}

export function finalizeProcess(data, parentProps, containerGridM) {
    var childCount = parentProps?.parentData?.childCount || 1;
    var childLoaded = parentProps?.parentData?.childLoaded || 0;
    if (!data.loaded) {
        data.loaded = true;
        parentProps.parentData.childLoaded = childLoaded + 1;

        console.debug("GO FINALIZE " + data.objType + " " + parentProps.parentData.childLoaded + "/" + childCount);

        if (parentProps.parentData.childLoaded >= childCount && !parentProps.parentData.loaded) {
            var parentSupProps = parentProps?.parentData?.functionManager?.getParentProps() || parentProps?.parentData?.functionManager.getParentProps()?.parentData?.functionManager?.getParentProps()
                || parentProps?.parentData?.functionManager.getParentProps()?.parentData?.functionManager?.getParentProps()?.parentData?.functionManager?.getParentProps();
            if (parentSupProps) finalizeProcess(parentProps.parentData, parentSupProps);
        }
    }
}

function getMergedDesign(data, designFragment, rootDesign, forcedMerge) {
    if ((forcedMerge || !data.mergedDesign)) {
        if (!designFragment) {
            designFragment = rootDesign;
        } else if (rootDesign) {
            designFragment = Object.assign({}, rootDesign, designFragment);
        }
    }
    else {
        designFragment = forcedMerge ? designFragment : data.mergedDesign;
    }
    return designFragment;
}